import { render, staticRenderFns } from "./AutocompleteSubject.vue?vue&type=template&id=894a3df0&scoped=true&"
import script from "./AutocompleteSubject.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894a3df0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
